import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { SelectItem } from 'primeng/api';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';

@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext">
            <p-autoComplete #content
                [hisDdKey]="options.ddKey"
                [formControl]="formControl"
                [suggestions]="filteredItems"
                (completeMethod)="search($event)"
                [dropdown]="true"
                [forceSelection]="true"
                [optionLabel]="'label'">
            </p-autoComplete>
        </his-plam>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class SelectComponent extends HisDynamicFieldBase<string> implements OnInit {

    item: SelectItem;
    items: SelectItem[];
    filteredItems: SelectItem[];
    options: HisDynamicFieldConfig;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.options = injectedData.options;
    }

    ngOnInit() {
        this.items = this.options.items;
        this.item = this.findDefaultItem( this.value );
        super.initFormControl( this.item );
    }

    // autocomplete
    search( event: { query: string } ) {
        this.filteredItems = this.items.filter(
            item => event.query === '' || item.label.toLowerCase().indexOf( event.query.toLowerCase() ) !== -1
        );
    }
 

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        let matchingConfig = this.searchFieldConfig( entireFormConfig );
        if ( matchingConfig !== null ) {
            this.items = matchingConfig.items;
            let selectedItem: SelectItem = this.findDefaultItem( matchingConfig.defaultValue );
            this.formControl.setValue( selectedItem, { emitEvent: false } );
        }
    }

    private findDefaultItem( defaultValue: string ): SelectItem {
        let selectedItem: SelectItem;
        selectedItem = this.items.find( item => defaultValue === item.value );
        if ( !selectedItem ) {
            selectedItem = { label: '', value: '' };
        }
        return selectedItem;
    }

    getControlValue(): any {
        return this.formControl.value ? this.formControl.value.value : '';
    }
}
